import api from './api';

export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const createProduct = (productData) => api.post('/products', productData);
export const updateProduct = (id, productData) => api.put(`/products/${id}`, productData);
export const deleteProduct = (id) => api.delete(`/products/${id}`);
export const addStock = (id, data) => api.post(`/products/${id}/stock/add`, data);
export const receiveStock = (id, data) => api.post(`/products/${id}/stock/receive`, data);
export const removeStock = (id, data) => api.post(`/products/${id}/stock/remove`, data);
export const returnStock = (id, data) => api.post(`/products/${id}/stock/return`, data);
export const getMovements = (params) => api.get('/products/movements/all', { params });
export const getLowStockAlerts = () => api.get('/products/alerts/low-stock');
export const getExpiringAlerts = () => api.get('/products/alerts/expiring');
export const resolveAlert = (id) => api.put(`/products/alerts/${id}/resolve`);
export const getCategories = () => api.get('/products/categories');
export const bulkImport = (formData) => api.post('/products/bulk-import', formData, {
  headers: { 'Content-Type': 'multipart/form-data' },
});
export const exportProducts = (params) => api.get('/products/export', {
  params,
  responseType: 'blob',
});
